import axios from '../utils/axios'

export function getHome() {
  return axios.get('/home');
}
export function getWx(params) {//
  return axios.post('/home/getwx', params);
}

